import { CJA } from "web-sdk";
import type { PluginName } from "web-sdk";

import { isDev } from "@/config";
import { getAccountId } from "@/js/account";

interface ICoreConfigProp {
  protocol?: "https:" | "http:";
  upload?:
    | "d.caijiyouxi.com/t.png"
    | "d-sgp.caijiyouxi.com/t.png"
    | "d.kaiheicloud.com/t.png";
  app_id?: "10010" | "10023" | "10027";
  is_dev?: boolean;
  plugins?: Array<PluginName>;
}

interface ITrackEventData {
  event_id: string;
  pageName?: string;
  from?: string;
  url?: string;
  act?: "customize_event";
  app_id?: "10023";
  uid?: string;
  cpid?: string;
  opid?: string;
  ver?: string;
  chan?: string;
  browser?: string;
  [key: string]: any;
}

const getUrlParams = (name: string) => {
  const reg = new RegExp("(?:^|&)" + name + "=([^&]*)(?:&|$)", "i");
  const r = window.location.search?.substring(1).match(reg);
  if (r === null) return "";
  return decodeURIComponent(r[1]);
};

const DERAULT_CONFIG: ICoreConfigProp = {
  app_id: "10023",
  upload: "d-sgp.caijiyouxi.com/t.png",
  is_dev: isDev,
  plugins: ["pageView", "pageDuration"],
  protocol: "https:",
};

const cja = new CJA(DERAULT_CONFIG).init().getApi();

(window as any)._hmt = (window as any)._hmt || [];

const baidukey =
  location.href.indexOf("caijiyouxi") > -1
    ? "3c187470b692e2d95f347970c5f35210"
    : "4fd140fb70890d9ffca9fe7c5e8bfe1e";

if (process.env.NODE_ENV != "development") {
  (function () {
    const hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?" + baidukey;
    hm.setAttribute("defer", "");
    const s: any = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();
}

const builtinData: Omit<ITrackEventData, "event_id" | "value" | "timestamp"> = {
  act: "web_perform",
  page_name: window.location.href,
  url: window.location.href,
  from: getUrlParams("from"),
  uid: getAccountId(),
  userAgent: window.navigator.userAgent,
  lan: window.navigator.language,
};

export const trackCustomizeEvent = (data: ITrackEventData) => {
  cja.trackCustomEvent(Object.assign(builtinData, data));
};
export default {
  addTrackEvent: function (
    category: string,
    action: string,
    opt_label?: string,
    opt_value?: string | number
  ) {
    if (!category || !action) {
      return;
    }

    const events: any[] = [category, action];

    if (opt_label) {
      events.push(opt_label);
    }

    if (opt_value) {
      events.push(opt_value);
    }

    (window as any)._hmt.push([
      "_trackEvent",
      category,
      action,
      opt_label,
      opt_value,
    ]);

    try {
      cja.tractCustomEvent({
        category,
        event_id: action,
        opt_label,
        opt_value,
      });
    } catch (error) {
      console.log("tractCustomEvent", error);
    }
  },
};
